import { mediaQuery, getMediaQuery } from '@jspartials/general-utils';

// Selectors
const selector = {
  bottomBarInfo: '.js-bottom-bar-info'
};

// Variables
const mediaQueryTablet = getMediaQuery(mediaQuery.tablet);

/**
 * Adds padding bottom to the body to avoid the footer to overlap the product info
 * @returns {void}
 */
const addPaddingToBody = () => {
  const productInfo = document.querySelector(selector.bottomBarInfo) || null;

  if (productInfo) {
    document.body.style.paddingBottom = `${productInfo.clientHeight}px`;
  }
};

/**
 * Removes the padding bottom to the body
 * @returns {void}
 */
const removePaddingToBody = () => {
  document.body.style.paddingBottom = `0px`;
};

const initBottomPadding = () => {
  // Resize
  mediaQueryTablet.addEventListener('change', function (mm) {
    if (!mm.matches) {
      addPaddingToBody();
    } else {
      removePaddingToBody();
    }
  });

  if (!mediaQueryTablet.matches) {
    addPaddingToBody();
  }
};

export { initBottomPadding };
